export enum DomElementTypes {
    BUTTON = "button",
    TOGGLE = "toggle",
    IMAGE = "image"
}